<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar
      :unread-count="pushUnreadCount"
      @open-notifications="openPushInbox"
    >
      <template slot="links">
        <li class="sidebar-highlight">
          <button
            v-for="(item, index) in defaultTopBarItens"
            :key="item.function || index"
            type="button"
            :class="sidebarHighlightItemClass(item)"
            :title="item.name"
            @click="runHighlightAction(item)"
          >
            <i :class="item.icon" aria-hidden="true"></i>
            <span
              v-if="item.function === 'showExpressModal'"
              class="sidebar-nova-reserva__label"
            >{{ item.name }}</span>
          </button>
        </li>
        <sidebar-item
          v-if="
            $store.state.auth.params.User &&
            $store.state.auth.params.User != undefined &&
            Object.keys(sideBarItens).length > 1
          "
          :link="homeMenu"
        />

        <div v-for="(role, index) in sideBarItens" :key="index">
          <sidebar-item
            v-if="
              role.controller.indexOf('report') < 0 &&
              role.action.indexOf('admin') < 0 &&
              (($store.state.auth.params.User &&
                $store.state.auth.params.User.indexpage !=
                  `${role.controller}/${role.action}`) ||
                Object.keys(sideBarItens).length == 1)
            "
            :key="index"
            :link="{
              name: role.name,
              path: `/${role.controller}/${role.action}`,
              icon: menuIconClasses(
                role.icon || getRoleIcon(role),
                $route.path == '/' + role.controller + '/' + role.action
              ),
            }"
          />
        </div>

        <!-- Relatórios -->
        <sidebar-item
          v-if="
            sideBarItens.filter(
              (role) => role.controller.indexOf('report') >= 0
            ).length > 0
          "
          :link="{
            name: 'Relatórios',
            icon: 'text-white ni ni-chart-bar-32',
          }"
        >
          <sidebar-item
            v-for="(role, index) in sideBarItens.filter(
              (role) => role.controller.indexOf('report') >= 0
            )"
            :key="index"
            :link="{
              name: '⯈ ' + role.name,
              path: `/${role.controller}/${role.action}`,
            }"
          />
        </sidebar-item>
        <!-- Administrativo -->

        <sidebar-item
          v-if="
            sideBarItens.filter((role) => role.action.indexOf('admin') >= 0)
              .length > 0
          "
          :link="{
            name: 'Administrativo',
            icon: 'text-white fa fa-users',
          }"
        >
          <sidebar-item
            v-for="(role, index) in sideBarItens.filter(
              (role) => role.action.indexOf('admin') >= 0
            )"
            :key="index"
            :link="{
              name: '⯈ ' + role.name,
              path: `/${role.controller}/${role.action}`,
            }"
          />
        </sidebar-item>

        <span class="w-100 d-block" style="cursor: pointer">
          <a
            href="#"
            class="nav-link"
            @click.prevent="openPushInbox"
          >
            <i class="fa fa-bell text-white" aria-hidden="true"></i>
            <span class="nav-link-text">
              Notificações
              <span
                v-if="pushUnreadCount > 0"
                class="badge badge-danger badge-pill ml-1"
              >{{ pushUnreadBadge }}</span>
            </span>
          </a>
        </span>
        <sidebar-item
          :link="{
            name: 'Configurações',
            icon: 'fa fa-cog text-white',
            path: '/configurations/index',
          }"
        />
        <span class="w-100 d-block" style="cursor: pointer">
          <a href="#" class="nav-link h-widget-trigger" @click.prevent>
            <i
              class="no no-c-question-3 text-white circle"
              style="font-size: 22px"
            ></i>
            <span class="nav-link-text">Ajuda</span>
          </a>
        </span>
        <a href="/logout" class="nav-link">
          <i>
            <span aria-hidden="true"
              ><svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H7.5"
                  stroke="#FFF"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />

                <path
                  d="M13.3334 14.1673L17.5 10.0007L13.3334 5.83398"
                  stroke="#FFF"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />

                <path
                  d="M17.5 10H7.5"
                  stroke="#FFF"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                />
              </svg>
            </span>
          </i>

          <span class="nav-link-text">Sair</span>
        </a>

        <!-- Templete sidebar Itens. Must to be hide in production mode.. -->
        <div v-show="!hideTemplateSidebarItens">
          <hr class="my-3" />
          <b-nav-item class="nav-item">
            <h6 class="navbar-heading text-white p-0">MENU COMPLETO DEV</h6>
          </b-nav-item>
          <sidebar-item
            :link="{
              name: 'DEV: Início',
              icon: 'no no-c-info text-white',
              path: '/dashboard/index',
            }"
          />
          <sidebar-item
            :link="{
              name: 'DEV: Atrativos',
              icon: 'no no-c-info text-white',
              path: '/products',
            }"
          />
          <sidebar-item
            :link="{
              name: 'DEV: Condutores',
              icon: 'no no-c-info text-white',
              path: '/agents/index',
            }"
          />
          <sidebar-item
            :link="{
              name: 'DEV: Clientes',
              path: '/clients',
              icon: 'no no-c-info text-white',
            }"
          />
          <sidebar-item
            :link="{
              name: 'DEV: Op. Calendário',
              icon: 'no no-c-info text-white',
              path: '/operation/index',
            }"
          />
          <sidebar-item
            :link="{
              name: 'DEV: Op. Reservas',
              icon: 'no no-c-info text-white',
              path: '/operation/booking-list',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Dev: Trafx',
              path: '/trafx',
              icon: 'no no-c-info text-white',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Dev: Requerimentos',
              path: '/issues',
              icon: 'no no-c-info text-white',
            }"
          />
          <sidebar-item
            :link="{
              name: 'DEV: Monitor de Serviços',
              path: '/clients/services',
              icon: 'no no-c-info text-white',
            }"
          />
          <sidebar-item
            :link="{
              name: 'DEV: Financeiro',
              icon: 'no no-c-info text-white',
              path: '/financial/index',
            }"
          />
          <sidebar-item
            :link="{
              name: 'DEV: Nota Fiscal',
              path: '/nf',
              icon: 'no no-c-info text-white',
            }"
          />
          <!-- Relatórios -->
          <sidebar-item
            :link="{
              name: 'DEV: Relatórios',
              icon: 'no no-c-info text-white',
            }"
          >
            <sidebar-item
              :link="{
                name: '⯈ DEV: vendas',
                path: '/reports/sales',
              }"
            />
            <sidebar-item
              :link="{
                name: '⯈ DEV: visitação',
                path: '/reports/visits',
              }"
            />
            <sidebar-item
              :link="{
                name: '⯈ DEV: seguro',
                path: '/reports/booking',
              }"
            />
            <sidebar-item
              :link="{
                name: '⯈ DEV: NPS',
                path: '/reports/nps',
              }"
            />
            <sidebar-item
              :link="{
                name: '⯈ DEV: Repasses',
                path: '/reports/withdraw',
              }"
            />
          </sidebar-item>
          <!-- Administrativo -->
          <sidebar-item
            :link="{
              name: 'DEV: Administrativo',
              icon: 'no no-c-info text-white',
            }"
          >
            <sidebar-item
              :link="{
                name: '⯈ DEV: Usuários',
                path: '/users/index',
              }"
            />
            <sidebar-item
              :link="{
                name: '⯈ DEV: Perfis',
                path: '/roles/index',
              }"
            />
            <sidebar-item
              :link="{
                name: '⯈ DEV: Permissões',
                path: '/permissions/index',
              }"
            />
            <sidebar-item
              :link="{
                name: '⯈ DEV: Mensageria',
                path: '/mensageria/admin',
              }"
            />
            <sidebar-item
              :link="{
                name: '⯈ DEV: Repasses',
                path: '/reports/withdraw',
              }"
            />
          </sidebar-item>
          <sidebar-item
            :link="{
              name: 'DEV: Configurações',
              icon: 'no no-c-info text-white',
              path: '/configurations/index',
            }"
          />
          <hr class="my-3" />
          <b-nav-item class="nav-item">
            <h6 class="navbar-heading text-white p-0">ACESSO RÁPIDO</h6>
          </b-nav-item>
          <!-- Reservas expressas -->
          <sidebar-item
            :link="{
              name: 'DEV: Reserva expressa',
              icon: 'no no-c-info text-white',
            }"
          >
            <sidebar-item
              :link="{
                name: '⯈ Todas as reservas',
                path: '/public-bookings',
              }"
            />
            <sidebar-item
              :link="{
                name: '⯈ DEV: Lençóis',
                path: '/booking/?eyJwbGFjZV91dWlkIjoiNTY2MkM4OTQtQUJBRS0xMUVDLThCRjYtRjIzQzkyMjdFQzhEIiwiJnVzZXJfdXVpZCI6IjM5NUVFQ0M3LTM4NDctMTFFRC04QUI1LUYyM0M5MjI3RUM4RCJ9',
              }"
            />
            <sidebar-item
              :link="{
                name: '⯈ DEV: Buracão',
                path: '/booking/?eyJwbGFjZV91dWlkIjoiMkYyNDkwNTYtQTc3OC0xMUVCLTk3MDItNTI1NDAwNkNDMzA5IiwiJnVzZXJfdXVpZCI6IkVEMTUwRTc2LTRCMzEtMTFFRC04NTM0LUYyM0M5MjI3RUM4RCJ9',
              }"
            />
          </sidebar-item>

          <!-- Exemplos do template -->
          <sidebar-item
            :link="{
              name: 'DEV: Exemplos do template',
              icon: 'no no-c-info text-white',
            }"
          >
            <sidebar-item
              :link="{
                name: '⯈ Components',
              }"
            >
              <sidebar-item
                :link="{
                  name: 'Buttons',
                  path: '/components/buttons',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Cards',
                  path: '/components/cards',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Grid System',
                  path: '/components/grid-system',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Notifications',
                  path: '/components/notifications',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Icons',
                  path: '/components/icons',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Typography',
                  path: '/components/typography',
                }"
              />
            </sidebar-item>
            <sidebar-item
              :link="{
                name: '⯈ Dashboard',
              }"
            >
              <sidebar-item
                :link="{
                  name: 'Dashboard template',
                  path: '/template/dashboard',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Alternative',
                  path: '/template/alternative',
                }"
              />
            </sidebar-item>
            <sidebar-item
              :link="{
                name: '⯈ Pages',
              }"
            >
              <sidebar-item
                :link="{
                  name: 'User Profile',
                  path: '/pages/user',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Timeline',
                  path: '/pages/timeline',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Home (landing)',
                  path: '/pages/home',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Pricing',
                  path: '/pages/pricing',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Lock',
                  path: '/pages/lock',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Register',
                  path: '/pages/register',
                }"
              />
            </sidebar-item>
            <sidebar-item
              :link="{
                name: '⯈ Starter',
                path: '/template/starter',
              }"
            />
            <sidebar-item
              :link="{
                name: '⯈ Widgets / Charts / Calendar',
              }"
            >
              <sidebar-item
                :link="{
                  name: 'Widgets',
                  path: '/template/widgets',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Charts',
                  path: '/template/charts',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Calendar',
                  path: '/template/calendar',
                }"
              />
            </sidebar-item>
            <sidebar-item
              :link="{
                name: '⯈ Forms',
              }"
            >
              <sidebar-item
                :link="{
                  name: 'Elements',
                  path: '/forms/elements',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Components',
                  path: '/forms/components',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Validation',
                  path: '/forms/validation',
                }"
              />
            </sidebar-item>
            <sidebar-item
              :link="{
                name: '⯈ Tables',
              }"
            >
              <sidebar-item
                :link="{
                  name: 'Regular',
                  path: '/tables/regular',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Sortable',
                  path: '/tables/sortable',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Paginated',
                  path: '/tables/paginated',
                }"
              />
            </sidebar-item>
            <sidebar-item
              :link="{
                name: '⯈ Maps',
              }"
            >
              <sidebar-item
                :link="{
                  name: 'Google',
                  path: '/maps/google',
                }"
              />
              <sidebar-item
                :link="{
                  name: 'Vector',
                  path: '/maps/vector',
                }"
              />
            </sidebar-item>
          </sidebar-item>
        </div>
      </template>

      <template slot="links-after">
        <div v-show="!hideTemplateSidebarItens">
          <hr class="my-3" />
          <h6 class="navbar-heading p-0 text-white">Documentation</h6>

          <b-nav class="navbar-nav mb-md-3" style="padding-bottom: 60px">
            <b-nav-item
              href="https://www.creative-tim.com/learning-lab/bootstrap-vue/quick-start/argon-dashboard"
            >
              <i class="ni ni-spaceship"></i>
              <b-nav-text class="p-0">Getting started</b-nav-text>
            </b-nav-item>
            <b-nav-item
              href="https://www.creative-tim.com/learning-lab/bootstrap-vue/colors/argon-dashboard"
            >
              <i class="ni ni-palette"></i>
              <b-nav-text class="p-0">Foundation</b-nav-text>
            </b-nav-item>
            <b-nav-item
              href="https://www.creative-tim.com/learning-lab/bootstrap-vue/avatar/argon-dashboard"
            >
              <i class="ni ni-ui-04"></i>
              <b-nav-text class="p-0">Components</b-nav-text>
            </b-nav-item>
            <b-nav-item
              href="https://www.creative-tim.com/learning-lab/bootstrap-vue/charts/argon-dashboard"
            >
              <i class="ni ni-chart-pie-35"></i>
              <b-nav-text class="p-0">Plugins</b-nav-text>
            </b-nav-item>
          </b-nav>
        </div>
      </template>
    </side-bar>
    <div class="main-content">
      <!-- Topbar oculto: nome/avatar foram para o sidenav. Não remover o componente ainda. -->
      <dashboard-navbar
        v-if="false"
        :type="$route.meta.navbarType"
      ></dashboard-navbar>

      <div
        class="sidenav-mobile-toggle d-xl-none"
        @click="$sidebar.displaySidebar(true)"
      >
        <div class="sidenav-toggler-inner">
          <i class="sidenav-toggler-line"></i>
          <i class="sidenav-toggler-line"></i>
          <i class="sidenav-toggler-line"></i>
        </div>
      </div>
      <div
        @click="$sidebar.displaySidebar(false)"
        class="pb-5"
        style="min-height: calc(100vh - 30px)"
      >
        <div class="sidenav-mobile-obscurator" v-if="isMobile">&nbsp;</div>
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer></content-footer>
    </div>

    <help-side-bar
      :loadingInfos="loadinfHelpInfo"
      @help-info-dismiss="showHelpSideBar = false"
      :info="sideBarInfos"
      :showHelpSideBar="showHelpSideBar"
    />
    <push-inbox-panel
      :open="showPushInbox"
      :items="pushInboxItems"
      :loading="pushInboxLoading"
      @close="showPushInbox = false"
      @marked-read="onPushMarkedRead"
      @marked-unread="onPushMarkedUnread"
    />
    <b-modal
      v-if="showReservaExpressaModal"
      v-model="showReservaExpressaModal"
      :hide-footer="true"
      :hide-header="false"
      size="lg"
      no-enforce-focus
    >
      <template #modal-header>
        <div class="w-100 d-inline-block text-left">
          <h4 class="w-100 d-inline-block modal-title">
            Criar nova reserva
            <button
              @click="closeReservaExpressaModal()"
              type="button"
              class="close d-inline"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </h4>
          <span class="w-100 text-muted d-inline-block"
            >Selecione um atrativo para registrar uma nova reserva</span
          >
        </div>
      </template>
      <public-bookings
        hide-header
        embedded
        :placeUuid="place.uuid"
        @close-public-bookings-modal="closeReservaExpressaModal"
      />
    </b-modal>
  </div>
</template>
<script src="/unicodesMap.json"></script>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar'
import { isMobile } from '@/store/utils/general'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import { mapGetters, mapActions } from 'vuex'
import HelpSideBar from '@/components/HelpSideBar/HelpSideBar'
import PushInboxPanel from '@/views/Mensageria/PushInboxPanel.vue'
import nodeService from '@/services/nodejs'
import {
  buildPushInboxWsUrl,
  bumpPushInboxCursorFromItems,
  persistPushInboxWsLocal,
  pushInboxItemTitle,
} from '@/views/Mensageria/utils/pushInboxWs'
import { getTokenNode } from '@/store/utils/tokenNode'
// import HelpDrawer from "@/components/HelpDrawer/HelpDrawer";
import DashboardNavbar from './DashboardNavbar.vue'
import ContentFooter from './ContentFooter.vue'
// import DashboardContent from "./Content.vue";
import { FadeTransition } from 'vue2-transitions'
import PublicBookings from '@/views/Products/PublicBookings.vue'
import store from '@/store'

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`)
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className)
    }, 100)
  }
}
export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    HelpSideBar,
    PushInboxPanel,
    // DashboardContent,
    FadeTransition,
    PublicBookings,
    // HelpDrawer
  },
  data() {
    return {
      myIframe: null,
      showReservaExpressaModal: false,
      onload: false,
      innerHeight: '700px',
      isMobile: isMobile(),
      bcClasses: '',
      hideNavbar: false,
      hideTemplateSidebarItens: true,
      sideBarItens: [],
      showHelpSideBar: false,
      sideBarInfos: '',
      loadinfHelpInfo: false,
      showPushInbox: false,
      pushInboxItems: [],
      pushInboxLoading: false,
      pushUnreadCount: 0,
      pushInboxWs: null,
      pushInboxWsRetry: null,
      defaultTopBarItens: [
        {
          name: 'Nova Reserva',
          icon: 'fa fa-plus',
          function: 'showExpressModal',
        },
      ],
      defaultSideBarItens: [
        {
          name: 'Início',
          controller: 'reports',
          action: 'dashboard/index',
        },
        {
          name: 'Atrativos  ',
          controller: 'products',
          action: 'index',
        },
        {
          name: 'Condutores',
          controller: 'agents',
          action: 'index',
        },
        {
          name: 'Veículos',
          controller: 'places',
          action: 'vehicles',
        },
        {
          name: 'Clientes',
          controller: 'clients',
          action: 'index',
        },
        {
          name: 'Calendário',
          controller: 'operation',
          action: 'index',
        },
        {
          name: 'Reservas',
          controller: 'operation',
          action: 'booking-list',
        },
        {
          name: 'Trafx',
          controller: 'trafx',
          action: 'index',
        },
        {
          name: 'Requerimentos',
          controller: 'issues',
          action: 'index',
        },
        {
          name: 'Monitor de Serviços',
          controller: 'clients',
          action: 'services',
        },
        {
          name: 'Financeiro',
          controller: 'financial',
          action: 'index',
        },
        {
          name: 'Nota Fiscal',
          controller: 'nf',
          action: 'index',
        },
        {
          name: 'Vendas',
          controller: 'reports',
          action: 'sales',
        },
        {
          name: 'Visitação',
          controller: 'reports',
          action: 'visits',
        },
        {
          name: 'Seguro',
          controller: 'reports',
          action: 'booking',
        },
        {
          name: 'Pesquisa de satisfação',
          controller: 'reports',
          action: 'nps',
        },
        {
          name: 'Repasses',
          controller: 'reports',
          action: 'withdraw',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('auth', {
      roles: 'getRules',
      place: 'getPlace',
      authUser: 'user',
    }),

    homeMenu() {
      let homeMenu = this.sideBarItens.find(
        (item) =>
          item.controller + '/' + item.action ==
          store.state.auth.params.User.indexpage
      )
      if (homeMenu == undefined) {
        homeMenu = { name: 'Início' }
      }
      return {
        name: homeMenu.name,
        icon: this.menuIconClasses(
          this.getRoleIcon('/' + this.$store.state.auth.params.User.indexpage),
          this.$route.path == '/' + this.$store.state.auth.params.User.indexpage
        ),
        path: `/${this.$store.state.auth.params.User.indexpage}`,
      }
    },
    pushUnreadBadge() {
      const n = Number(this.pushUnreadCount) || 0
      if (n <= 0) return ''
      return n > 99 ? '99+' : String(n)
    },
  },
  methods: {
    closeReservaExpressaModal() {
      this.showReservaExpressaModal = false
    },
    ...mapActions('product', ['setIsLoading']),
    onLoad(frame) {
      this.myIframe = frame.contentWindow
      setTimeout(() => {
        this.setIsLoading(false)
      }, 2000)
    },

    showExpressModal() {
      this.showReservaExpressaModal = true
    },

    runHighlightAction(item) {
      const action = item && item.function
      if (action && typeof this[action] === 'function') {
        this[action]()
      }
    },
    sidebarHighlightItemClass(item) {
      if (item && item.function === 'showExpressModal') {
        return 'sidebar-nova-reserva'
      }
      return [
        'sidebar-highlight-item',
        'text-blue',
        'bg-white',
        {
          'sidebar-highlight-item--bell':
            item && item.function === 'openPushInbox',
        },
      ]
    },
    async openPushInbox() {
      this.showPushInbox = true
      if (this.$sidebar && this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
      await this.fetchPushInbox()
    },
    async fetchPushUnreadCount() {
      if (!getTokenNode()) return
      try {
        const { data } = await nodeService.getMessengerPushInboxUnreadCount()
        this.pushUnreadCount = Number((data && data.unread_count) || 0)
      } catch (err) {
        // Inbox pode falhar se API antiga; não bloqueia o layout
        console.warn('push inbox unread', err)
      }
    },
    async fetchPushInbox() {
      if (!getTokenNode()) return
      this.pushInboxLoading = true
      try {
        // Lista completa do painel (sem since). Cursor local só vai no WS connect.
        const { data } = await nodeService.getMessengerPushInbox({
          page: 1,
          limit: 50,
        })
        this.pushInboxItems = (data && data.items) || []
        if (data && typeof data.unread_count === 'number') {
          this.pushUnreadCount = data.unread_count
        }
        const username =
          (this.$store.state.auth &&
            this.$store.state.auth.user &&
            this.$store.state.auth.user.username) ||
          null
        // Lista REST: atualiza cursor sem desktop notify (só WS/cursor live).
        bumpPushInboxCursorFromItems(this.pushInboxItems, { username })
      } catch (err) {
        console.error('push inbox list', err)
        this.pushInboxItems = []
      } finally {
        this.pushInboxLoading = false
      }
    },
    /**
     * Element UI $notify por mensagem chegada (título), com 1s entre cada.
     * Dispara em inbox.notification (sempre) ou quando o cursor local avança
     * (primeira gravação / stamp mais novo) — tipicamente inbox.sync.
     */
    maybeNotifyPushInboxVue(shouldNotify, items) {
      if (!shouldNotify) return
      const list = (Array.isArray(items) ? items : []).filter(Boolean)
      if (!list.length) return
      if (!Array.isArray(this._pushInboxVueNotifyQueue)) {
        this._pushInboxVueNotifyQueue = []
      }
      list.forEach((item) => {
        this._pushInboxVueNotifyQueue.push(pushInboxItemTitle(item))
      })
      this.drainPushInboxVueNotifies()
    },
    drainPushInboxVueNotifies() {
      if (this._pushInboxVueNotifyBusy) return
      const queue = this._pushInboxVueNotifyQueue
      if (!Array.isArray(queue) || !queue.length) return
      const message = queue.shift()
      if (typeof this.$notify === 'function') {
        this.$notify({
          message,
          duration: 6000,
          type: 'success',
        })
      }
      this._pushInboxVueNotifyBusy = true
      if (this._pushInboxVueNotifyTimer) {
        clearTimeout(this._pushInboxVueNotifyTimer)
      }
      this._pushInboxVueNotifyTimer = setTimeout(() => {
        this._pushInboxVueNotifyBusy = false
        this._pushInboxVueNotifyTimer = null
        this.drainPushInboxVueNotifies()
      }, 1000)
    },
    onPushMarkedRead(payload) {
      const id = payload && payload.id
      const readAt = (payload && payload.read_at) || new Date().toISOString()
      this.pushInboxItems = this.pushInboxItems.map((row) => {
        if (row.id !== id) return row
        return { ...row, read: true, read_at: readAt }
      })
      if (typeof (payload && payload.unread_count) === 'number') {
        this.pushUnreadCount = payload.unread_count
      } else {
        this.pushUnreadCount = Math.max(0, (Number(this.pushUnreadCount) || 0) - 1)
      }
    },
    onPushMarkedUnread(payload) {
      const id = payload && payload.id
      this.pushInboxItems = this.pushInboxItems.map((row) => {
        if (row.id !== id) return row
        let message = row.message
        if (message && typeof message === 'object' && !Array.isArray(message)) {
          const next = { ...message }
          delete next.inbox_read_at
          message = next
        }
        return { ...row, read: false, read_at: null, message }
      })
      if (typeof (payload && payload.unread_count) === 'number') {
        this.pushUnreadCount = payload.unread_count
      } else {
        this.pushUnreadCount = (Number(this.pushUnreadCount) || 0) + 1
      }
    },
    connectPushInboxWs() {
      if (!getTokenNode() || typeof WebSocket === 'undefined') return
      this.disconnectPushInboxWs()
      try {
        const ws = new WebSocket(buildPushInboxWsUrl())
        this.pushInboxWs = ws
        ws.onmessage = (event) => {
          try {
            if (!event.data || event.data === 'recebido!') return
            const msg = JSON.parse(event.data)
            if (!msg || !msg.type) return
            if (typeof msg.unread_count === 'number') {
              this.pushUnreadCount = msg.unread_count
            }
            const username =
              (this.$store.state.auth &&
                this.$store.state.auth.user &&
                this.$store.state.auth.user.username) ||
              null
            // Catch-up: sem cursor → API unread_only 24h; com since → delta completo.
            if (msg.type === 'inbox.sync' && Array.isArray(msg.items)) {
              const byId = {}
              // unread_only bootstrap: não apaga itens já na memória; só mescla.
              this.pushInboxItems.forEach((row) => {
                byId[row.id] = row
              })
              msg.items.forEach((item) => {
                if (item && item.id != null) byId[item.id] = item
              })
              this.pushInboxItems = Object.keys(byId)
                .map((k) => byId[k])
                .sort((a, b) => {
                  const am = a && a.send_date ? String(a.send_date) : ''
                  const bm = b && b.send_date ? String(b.send_date) : ''
                  return am < bm ? 1 : am > bm ? -1 : 0
                })
              const bumped = bumpPushInboxCursorFromItems(msg.items, { username })
              if (msg.items.length > 0) {
                this.maybeNotifyPushInboxVue(bumped.cursorAdvanced, msg.items)
              }
            }
            if (msg.type === 'inbox.notification' && msg.item) {
              const exists = this.pushInboxItems.some((r) => r.id === msg.item.id)
              if (!exists) {
                this.pushInboxItems = [msg.item, ...this.pushInboxItems]
              }
            }
            if (msg.type === 'inbox.read' && msg.id != null) {
              this.pushInboxItems = this.pushInboxItems.map((row) =>
                row.id === msg.id
                  ? { ...row, read: true, read_at: msg.read_at || row.read_at }
                  : row
              )
            }
            if (msg.type === 'inbox.unread' && msg.id != null) {
              this.pushInboxItems = this.pushInboxItems.map((row) => {
                if (row.id !== msg.id) return row
                let message = row.message
                if (message && typeof message === 'object' && !Array.isArray(message)) {
                  const next = { ...message }
                  delete next.inbox_read_at
                  message = next
                }
                return { ...row, read: false, read_at: null, message }
              })
            }
            // Persist newest stamp; read ids on inbox.read; clear on unread
            if (
              msg.type === 'inbox.notification' ||
              msg.type === 'inbox.read' ||
              msg.type === 'inbox.unread'
            ) {
              persistPushInboxWsLocal(msg, { username })
              // Nova notificação: um $notify por item (independente do cursor).
              if (msg.type === 'inbox.notification' && msg.item) {
                this.maybeNotifyPushInboxVue(true, [msg.item])
              }
            }
          } catch (e) {
            console.warn('push inbox ws message', e)
          }
        }
        ws.onclose = () => {
          this.pushInboxWs = null
          if (this.pushInboxWsRetry) clearTimeout(this.pushInboxWsRetry)
          this.pushInboxWsRetry = setTimeout(() => {
            this.connectPushInboxWs()
          }, 8000)
        }
        ws.onerror = () => {
          try {
            ws.close()
          } catch (e) {
            /* noop */
          }
        }
      } catch (err) {
        console.warn('push inbox ws connect', err)
      }
    },
    disconnectPushInboxWs() {
      if (this.pushInboxWsRetry) {
        clearTimeout(this.pushInboxWsRetry)
        this.pushInboxWsRetry = null
      }
      if (this.pushInboxWs) {
        try {
          this.pushInboxWs.onclose = null
          this.pushInboxWs.close()
        } catch (e) {
          /* noop */
        }
        this.pushInboxWs = null
      }
    },
    // Ícones Font Awesome (fas/fa) usam a classe "cicle" para a borda
    // arredondada. Ícones Nucleo "no" usam "circle" (.no.circle).
    menuIconClasses(icon, active) {
      if (!active) return icon
      const shape = /(^|\s)(fas|far|fab|fa)(\s|$)/.test(icon)
        ? 'cicle'
        : 'circle'
      return `${icon} text-blue bg-white ${shape}`
    },
    getRoleIcon(role) {
      let icon = 'no no-file-text-3'
      let path =
        typeof role === 'string' ? role : `/${role.controller}/${role.action}`
      switch (path) {
        case '/agents/index':
          icon = 'no no-users'
          break

        case '/reports/sales':
          icon = 'no no-file-text-3'
          break

        case '/reports/visits':
          icon = 'no no-file-text-3'
          break

        case '/financial/index':
          icon = 'ni ni-money-coins'
          break

        case '/agents/':
          icon = 'no no-users'
          break

        case '/agents/index':
          icon = 'ni ni-single-02'
          break

        case '/products/index':
          icon = 'ni ni-square-pin'
          break

        case '/places/vehicles':
          icon = 'fas fa-car'
          break

        case '/financial/index':
          icon = 'no no-money-coins'
          break

        case '/operation/index':
          icon = 'ni ni-calendar-grid-58'
          break

        case '/operation/booking-list':
          icon = 'no no-bookmark'
          break
        case '/trafx/index':
          icon = 'ni ni-sound-wave'
          break

        case '/financial/nflist':
          icon = 'ni ni-paper-diploma'
          break

        case '/issues/index':
          icon = 'ni ni-paper-diploma'
          break

        case '/reports/visits/dashboard':
          icon = 'no no-house-6'
          break
        case '/configurations/index':
          icon = 'no no-cogwheel'
          break
        case '/mensageria/admin':
          icon = 'ni ni-bell-55'
          break
        default:
          icon = 'no no-plus'
          break
      }
      return icon
    },
    handleSideBarRoles() {
      for (var l in this.roles) {
        let sideBarElements = this.roles[l].filter((element) => {
          let visible = element.visible === 'main-menu'
          if (visible) {
            element.icon = this.getRoleIcon(element)
          }
          return visible
        })
        sideBarElements ? this.sideBarItens.push(...sideBarElements) : ''
      }
      const orderedSideBarItens = []
      const notFoundedMenuItems = []
      this.defaultSideBarItens.map((defaultMenuItem) => {
        const foundedMenuItem = this.sideBarItens.find(
          (userMenuItem) =>
            userMenuItem.controller === defaultMenuItem.controller &&
            userMenuItem.action === defaultMenuItem.action
        )
        if (foundedMenuItem) {
          orderedSideBarItens.push(foundedMenuItem)
        } else {
          notFoundedMenuItems.push(defaultMenuItem)
        }
      })

      this.sideBarItens.map((userMenuItem) => {
        const foundedOrderedMenuItem = orderedSideBarItens.find(
          (orderedMenuItem) => {
            return (
              userMenuItem.controller === orderedMenuItem.controller &&
              (userMenuItem.action == '' ||
                userMenuItem.action === orderedMenuItem.action)
            )
          }
        )
        if (!foundedOrderedMenuItem) {
          orderedSideBarItens.push(userMenuItem)
        }
      })
      this.sideBarItens = orderedSideBarItens
    },
    // O script do chat liga os gatilhos no load da página, antes do menu existir.
    bindHelpChatTrigger() {
      if (window.hWidget && typeof window.hWidget.bindTriggers === 'function') {
        window.hWidget.bindTriggers()
      }
    },
    showHelpChoknowledgebase() {
      this.showHelpSideBar = true
      this.$sidebar.displaySidebar(false)
      var aparentPath = this.$route.path.split('/')[1]
      this.getArticleseChoknowledgebase(aparentPath)
    },
    getArticleseChoknowledgebase(path) {
      this.loadinfHelpInfo = true
      setTimeout(() => {
        this.loadinfHelpInfo = false
      }, 2000)
    },
    initScrollbar() {
      let isWindows = navigator.platform.startsWith('Win')
      if (isWindows) {
      }
      initScrollbar('sidenav')
    },
  },
  mounted() {
    this.hideTemplateSidebarItens = process.env.NODE_ENV === 'production'
    this.initScrollbar()
    this.handleSideBarRoles()
    this.bindHelpChatTrigger()
    this.fetchPushUnreadCount()
    this.connectPushInboxWs()
  },
  beforeDestroy() {
    if (this._pushInboxVueNotifyTimer) {
      clearTimeout(this._pushInboxVueNotifyTimer)
      this._pushInboxVueNotifyTimer = null
    }
    this._pushInboxVueNotifyBusy = false
    this._pushInboxVueNotifyQueue = []
    this.disconnectPushInboxWs()
  },
  created() {
    if (window.location.origin.indexOf('//localhost') >= 0) {
      window.location.href = window.location.href.replace(
        '//localhost',
        '//127.0.0.1'
      )
      return false
    }
    if (
      window.location.href.indexOf('janoo.com.br') > 0 ||
      this.$route.query.hosted == 'janoo'
    ) {
      this.bcClasses += 'janoo_hosteded '
    }
  },
}
</script>

<style>
/* cicle: borda arredondada dos ícones Font Awesome (fas/fa),
   equivalente a .no.circle da família Nucleo. */
.fas.cicle,
.far.cicle,
.fab.cicle,
.fa.cicle {
  border-radius: 50%;
}

</style>
